export default __webpack_public_path__ + "static/media/placeholder-property.732cc5eb.jpeg";